import { createContext, useContext, useState } from 'react';

const UtilityContext = createContext();

export function useUtility() {
  return useContext(UtilityContext);
}

export function UtilityProvider(props) {
  const [customModalOpen, setCustomModalOpen] = useState(false);

  const { children } = props;

  const contextValues = {
    customModalOpen,
    setCustomModalOpen,
  };

  return (
    <UtilityContext.Provider value={contextValues}>
      {children}
    </UtilityContext.Provider>
  );
}
